import { render, staticRenderFns } from "./EProtocoloModal.vue?vue&type=template&id=fc889dbe&"
import script from "./EProtocoloModal.vue?vue&type=script&lang=js&"
export * from "./EProtocoloModal.vue?vue&type=script&lang=js&"
import style0 from "./EProtocoloModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports